<template>
  <v-card class="rounded-card"
          flat
  >
    <v-card-text>
      <px-campos-integracao type="fornecedor"
                            :form-data="cadastrosAdicionais"/>
    </v-card-text>
    <v-card-actions class="ml-3" v-if="isTotvs">
      <v-btn class="normal-btn-text elevation-0 rounded-tag-small mb-3"
             color="primary"
             :loading="loading"
             @click="saveCadastrosAdicionais">
        Salvar
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex';
import { getCadastroAdicional } from '@/modules/cadastros-adicionais/cadastros-adicionais-utils';
import GestaoFornecedorService from '@/modules/gestao-fornecedor/gestao-fornecedor-service';
import {
  validateCamposErp,
  initialStateCamposErp,
} from '@/modules/gestao-fornecedor/gestao/campos-erp/validate-campos-erp';

export default {
  props: {
    fornecedor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      cadastrosAdicionais: null,
      loading: false,
    };
  },
  computed: {
    ...mapGetters('user', ['erpCamposIntegracao']),
    isTotvs() {
      return this.erpCamposIntegracao === 'TOTVS';
    },
  },
  methods: {
    setupCadastrosAdicionais() {
      this.cadastrosAdicionais.natureza = getCadastroAdicional(this.fornecedor.cadastrosAdicionais, 'NATUREZA');
    },
    emitUpdate() {
      this.$emit('update');
    },
    buildCadastrosAdicionaisPayload() {
      if (!this.cadastrosAdicionais) {
        return [];
      }
      return [
        this.cadastrosAdicionais.natureza,
      ].map((cadastro) => {
        if (cadastro) {
          return {
            id: cadastro.id,
          };
        }
        return null;
      }).filter(cadastro => cadastro);
    },
    buildPayload() {
      return {
        cadastrosAdicionais: this.buildCadastrosAdicionaisPayload(),
      };
    },
    validateCadastrosAdicionais() {
      const [isValid, message] = validateCamposErp(this.erpCamposIntegracao,
        this.cadastrosAdicionais);
      if (!isValid) {
        this.$toast(message, { color: 'error' });
      }
      return isValid;
    },
    saveCadastrosAdicionais() {
      if (!this.validateCadastrosAdicionais()) {
        return;
      }
      this.loading = true;
      this.buildPayload();
      GestaoFornecedorService.update(this.fornecedor.id, this.buildPayload())
        .then(() => {
          this.$toast('Fornecedor atualizado', { color: 'success' });
          this.$emit('update');
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  created() {
    this.cadastrosAdicionais = initialStateCamposErp(this.erpCamposIntegracao);
    this.setupCadastrosAdicionais();
  },
};
</script>
